import React from 'react';
import { InferGetStaticPropsType } from 'next';
import { layouts } from 'constants/layouts';
import { getArticles, Article } from 'libs/microcms';
import { BlogArticle } from 'components/Blog/BlogArticle';
import DefaultHead from 'components/DefaultHead';
import { Box, Text } from '@chakra-ui/react';
import striptags from 'striptags';
import { BlogArticles } from 'components/Blog/BlogArticles';
import { ShareSticky } from 'components/Blog/ShareSticky';
import { paths } from 'constants/paths';

export async function getStaticPaths() {
  const { contents: blogs } = await getArticles({ orders: '-publishedDate' });

  return {
    paths: blogs.map((blog) => ({ params: { slug: blog.slug } })),
    fallback: false,
  };
}

export const getStaticProps = async ({ params }: any) => {
  const { contents: currentArticles } = await getArticles({
    filters: `slug[equals]${params.slug}`,
  });

  const { contents: orderArticles } = await getArticles({
    orders: '-publishedDate',
    limit: 3,
    filters: `slug[not_equals]${params.slug}`,
  });

  return {
    props: {
      layout: layouts.default,
      currentArticle: currentArticles[0] as Article,
      orderArticles,
    },
    revalidate: 60 * 60 * 12,
  };
};

const Index = (props: InferGetStaticPropsType<typeof getStaticProps>) => {
  const { currentArticle, orderArticles } = props;

  return (
    <Box>
      <DefaultHead
        title={`${currentArticle.title} - shizai`}
        description={striptags(currentArticle.body).substring(0, 80)}
        url={
          process.env.NEXT_PUBLIC_ORIGIN + paths.blogDetail({ blogFriendlyId: currentArticle.slug })
        }
        image={currentArticle.image.url}
      />
      <BlogArticle article={currentArticle} />
      <Box p={{ base: '72px 24px 0', md: '72px 0' }}>
        <Text as="h2" textStyle="h2" whiteSpace="pre-wrap" mb="24px">
          その他の記事
        </Text>
        <BlogArticles articles={orderArticles} />
      </Box>
      <ShareSticky
        title={currentArticle.title}
        url={
          process.env.NEXT_PUBLIC_ORIGIN + paths.blogDetail({ blogFriendlyId: currentArticle.slug })
        }
      />
    </Box>
  );
};

export default Index;
